<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<hr class="chap2"/>
<h2 id="CONTENTS">CONTENTS</h2>
</div>
<table class="autotable" summary="" width="95%">
<tbody class="calibre2"><tr class="calibre3">
<td class="tdr"></td>
<td class="tdl"></td>
<td class="tdr1">PAGE</td>
</tr>
<tr class="calibre3">
<td class="tdr"></td>
<td class="tdl">IN APPRECIATION OF WILLIAM F. CODY</td>
<td class="tdr"><a href="#/Text/Section0003#Page_1">1</a></td>
</tr>
<tr class="calibre3">
<td class="tdr">I.</td>
<td class="tdl">JUNIPER JOE’S JUBILEE.</td>
<td class="tdr"><a href="#/Text/Section0004#CHAPTER_I">5</a></td>
</tr>
<tr class="calibre3">
<td class="tdr">II.</td>
<td class="tdl">“JACKSON DANE, DETECTIVE.”</td>
<td class="tdr"><a href="#/Text/Section0005#Page_15">15</a></td>
</tr>
<tr class="calibre3">
<td class="tdr">III.</td>
<td class="tdl">THE BARON FINDS EXCITEMENT.</td>
<td class="tdr"><a href="#/Text/Section0006#Page_29">29</a></td>
</tr>
<tr class="calibre3">
<td class="tdr">IV.</td>
<td class="tdl">SUSPICIONS.</td>
<td class="tdr"><a href="#/Text/Section0007#Page_40">40</a></td>
</tr>
<tr class="calibre3">
<td class="tdr">V.</td>
<td class="tdl">THE SURPRISE AT JUNIPER JOE’S.</td>
<td class="tdr"><span href="#/Text/Section0008#Page_49" title="Link target outside of Sample">49</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">VI.</td>
<td class="tdl">THE BARON’S ADVENTURES.</td>
<td class="tdr"><span href="#/Text/Section0009#Page_57" title="Link target outside of Sample">57</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">VII.</td>
<td class="tdl">A STARTLING DISCOVERY.</td>
<td class="tdr"><span href="#/Text/Section0010#Page_71" title="Link target outside of Sample">71</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">VIII.</td>
<td class="tdl">STRANGE DISAPPEARANCES.</td>
<td class="tdr"><span href="#/Text/Section0011#Page_83" title="Link target outside of Sample">83</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">IX.</td>
<td class="tdl">THE CHASE.</td>
<td class="tdr"><span href="#/Text/Section0012#Page_88" title="Link target outside of Sample">88</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">X.</td>
<td class="tdl">STARTLING REVELATIONS.</td>
<td class="tdr"><span href="#/Text/Section0013#Page_99" title="Link target outside of Sample">99</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XI.</td>
<td class="tdl">THE FOOL OF FOLLY MOUNTAIN.</td>
<td class="tdr"><span href="#/Text/Section0014#Page_106" title="Link target outside of Sample">106</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XII.</td>
<td class="tdl">THE MISSION OF WHITE-EYED MOSES.</td>
<td class="tdr"><span href="#/Text/Section0015#Page_117" title="Link target outside of Sample">117</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XIII.</td>
<td class="tdl">BENSON ACTS.</td>
<td class="tdr"><span href="#/Text/Section0016#Page_127" title="Link target outside of Sample">127</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XIV.</td>
<td class="tdl">A WORRIED SHERIFF.</td>
<td class="tdr"><span href="#/Text/Section0017#Page_133" title="Link target outside of Sample">133</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XV.</td>
<td class="tdl">THE SHERIFF’S WARNING.</td>
<td class="tdr"><span href="#/Text/Section0018#Page_145" title="Link target outside of Sample">145</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XVI.</td>
<td class="tdl">THE GOPHER BITES.</td>
<td class="tdr"><span href="#/Text/Section0019#Page_151" title="Link target outside of Sample">151</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XVII.</td>
<td class="tdl">THE BARON’S EXPERIENCE.</td>
<td class="tdr"><span href="#/Text/Section0020#Page_158" title="Link target outside of Sample">158</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XVIII.</td>
<td class="tdl">AN ASSASSIN AT WORK.</td>
<td class="tdr"><span href="#/Text/Section0021#Page_167" title="Link target outside of Sample">167</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XIX.</td>
<td class="tdl">SHIFTING THE PRISONERS.</td>
<td class="tdr"><span href="#/Text/Section0022#Page_182" title="Link target outside of Sample">182</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XX.</td>
<td class="tdl">SPRINGING THE TRAP.</td>
<td class="tdr"><span href="#/Text/Section0023#Page_196" title="Link target outside of Sample">196</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXI.</td>
<td class="tdl">TIM BENSON’S ESCAPE.</td>
<td class="tdr"><span href="#/Text/Section0024#Page_206" title="Link target outside of Sample">206</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXII.</td>
<td class="tdl">TIM BENSON’S CLEVERNESS.</td>
<td class="tdr"><span href="#/Text/Section0025#Page_211" title="Link target outside of Sample">211</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXIII.</td>
<td class="tdl">BUFFALO BILL’S HOLD-UP.</td>
<td class="tdr"><span href="#/Text/Section0026#Page_221" title="Link target outside of Sample">221</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXIV.</td>
<td class="tdl">GORILLA JAKE.</td>
<td class="tdr"><span href="#/Text/Section0027#Page_237" title="Link target outside of Sample">237</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXV.</td>
<td class="tdl">THE BETTS BROTHERS.</td>
<td class="tdr"><span href="#/Text/Section0028#Page_253" title="Link target outside of Sample">253</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXVI.</td>
<td class="tdl">IN THE UTE VILLAGES.</td>
<td class="tdr"><span href="#/Text/Section0029#Page_259" title="Link target outside of Sample">259</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXVII.</td>
<td class="tdl">MATT SHEPARD AND THE MASSACRE.</td>
<td class="tdr"><span href="#/Text/Section0030#Page_263" title="Link target outside of Sample">263</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXVIII.</td>
<td class="tdl">HOW IT WORKED.</td>
<td class="tdr"><span href="#/Text/Section0031#Page_275" title="Link target outside of Sample">275</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXIX.</td>
<td class="tdl">THE DARING OF BILL BETTS.</td>
<td class="tdr"><span href="#/Text/Section0032#Page_294" title="Link target outside of Sample">294</span></td>
</tr>
<tr class="calibre3">
<td class="tdr">XXX.</td>
<td class="tdl">THE CAPTURE OF BENSON.</td>
<td class="tdr"><span href="#/Text/Section0033#Page_305" title="Link target outside of Sample">305</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?30cef7b4